import iconWallet from "../../../../design/assests/images/pdf_icons/wallet.png"
import { numberFormatter } from "../../../../utils/numbers.utils"
import { formatDateRange } from "../../../../utils/date.utils"
import { getEstimatedBudgetEnd } from "../../../../utils/budget.utils"
import html2canvas from "html2canvas"

export const buildBudgetStateSection = async (
  doc,
  sprintData,
  visibleMap,
  y,
  budgetData,
  refsToCapture,
  extraData
) => {
  const pageWidth = doc.internal.pageSize.getWidth()
  const sideMargin = 10
  const usableWidth = pageWidth - sideMargin * 2
  const colWidth = usableWidth / 3

  const titleColor = "#24292F"
  const labelColor = "#737E8D"
  const valueColor = "#24292F"

  const iconSize = 6
  const spacing = 2
  const iconOffsetY = 4.5

  const safeBudget = budgetData || {}

  const totalBilledTime =
    extraData?.accumulatedPeriodConsumption ?? safeBudget.totalBilledTime

  const budgetEndDate =
    extraData?.estimatedEndDate ?
      `~ ${formatDateRange(extraData.estimatedEndDate, extraData.estimatedEndDate)}`
    : "-"

  const remaining = (safeBudget.totalBudget || 0) - (totalBilledTime || 0)

  const getFinPresupuesto = () => {
    const estimated = getEstimatedBudgetEnd(
      remaining,
      safeBudget.lastEightWeeksTruncatedMean * 4,
      safeBudget.lastEightWeeksTruncatedMean * 4
    )

    return estimated?.estimatedEndMaxDate ?
        formatDateRange(
          estimated.estimatedEndMaxDate,
          estimated.estimatedEndMaxDate
        )
      : "-"
  }

  doc.addImage(
    iconWallet,
    "PNG",
    sideMargin,
    y - iconOffsetY,
    iconSize,
    iconSize
  )

  doc.setFont("Cairo-SemiBold", "normal")
  doc.setFontSize(9)
  doc.setTextColor(titleColor)
  doc.text("Estado del presupuesto", sideMargin + iconSize + spacing, y)

  y += 8

  doc.setFont("Mulish-Bold", "normal")
  doc.setFontSize(7.5)
  doc.setTextColor(labelColor)

  doc.text("Consumo total al corte", sideMargin, y)
  doc.text("Horas disponibles", sideMargin + colWidth, y)
  doc.text("Fin estimado del presupuesto", sideMargin + colWidth * 2, y)

  y += 6

  doc.setFont("Cairo-Bold", "normal")
  doc.setFontSize(12)
  doc.setTextColor(valueColor)

  const consumoTotal =
    safeBudget.hasBudget ? numberFormatter(Math.max(remaining, 0)) : "-"

  const horasDisponibles =
    safeBudget.hasBudget ?
      `${numberFormatter(totalBilledTime)} / ${numberFormatter(
        safeBudget.totalBudget
      )}`
    : "-"

  if (safeBudget.hasBudget) {
    const value = numberFormatter(totalBilledTime || 0)

    doc.setFont("Cairo-SemiBold", "normal")
    doc.setFontSize(12)

    const valueWidth = doc.getTextWidth(value)

    doc.text(value, sideMargin, y)

    doc.setFontSize(9)
    doc.text("horas", sideMargin + valueWidth + 1, y)
  } else {
    doc.text("-", sideMargin, y)
  }

  if (safeBudget.hasBudget) {
    const mainValue = numberFormatter(remaining)
    const secondaryValue = `/${numberFormatter(safeBudget.totalBudget)} horas`

    const horasX = sideMargin + colWidth

    doc.setFont("Cairo-SemiBold", "normal")
    doc.setFontSize(12)

    const mainWidth = doc.getTextWidth(mainValue)

    doc.text(mainValue, horasX, y)

    doc.setFontSize(9)
    doc.text(secondaryValue, horasX + mainWidth, y)
  } else {
    doc.text("-", sideMargin + colWidth, y)
  }

  doc.setFont("Cairo-SemiBold", "normal")
  doc.setFontSize(12)
  doc.text(budgetEndDate, sideMargin + colWidth * 2, y)

  y += 7

  doc.setFont("Mulish-Bold", "normal")
  doc.setFontSize(7.5)
  doc.setTextColor(labelColor)
  doc.text("Porcentaje de consumo", sideMargin, y)

  y += 2

  const budgetGraphDiv = refsToCapture.BUDGET_STATE

  if (budgetGraphDiv) {
    try {
      const lightClone = budgetGraphDiv.cloneNode(true)

      const percentage =
        safeBudget.totalBudget > 0 ?
          totalBilledTime / safeBudget.totalBudget
        : 0

      const rect = budgetGraphDiv.getBoundingClientRect()

      lightClone.style.width = rect.width + "px"
      lightClone.style.height = rect.height + "px"
      lightClone.style.display = "block"
      lightClone.style.background = "#ffffff"
      lightClone.style.backgroundColor = "#ffffff"

      const barBase = lightClone.querySelector(".p-progressbar")
      if (barBase) {
        barBase.style.background = "#E0E2E5"
        barBase.style.backgroundColor = "#E0E2E5"
      }

      const barValue = lightClone.querySelector(".p-progressbar-value")
      if (barValue) {
        if (percentage > 0) {
          barValue.style.background = "#0A5587"
          barValue.style.backgroundColor = "#0A5587"
        } else {
          barValue.style.background = "transparent"
          barValue.style.backgroundColor = "transparent"
        }
      }

      // Ocultamos el label nativo en el clon
      const style = document.createElement("style")
      style.textContent = `
      .p-progressbar { border-radius: 6px; overflow: hidden; }
      .p-progressbar-value { border-radius: 6px 0 0 6px; }
      .p-progressbar-label { display: none !important; }
    `
      lightClone.insertBefore(style, lightClone.firstChild)

      document.body.appendChild(lightClone)

      const canvas = await html2canvas(lightClone, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      })

      document.body.removeChild(lightClone)

      const imgData = canvas.toDataURL("image/png")
      const graphWidth = usableWidth
      const graphHeight = 6
      const borderRadius = 1

      // Dibujar fondo gris completo CON BORDES REDONDEADOS
      doc.setFillColor(224, 226, 229)
      doc.roundedRect(
        sideMargin,
        y,
        graphWidth,
        graphHeight,
        borderRadius,
        borderRadius,
        "F"
      )

      // Calcular porcentaje y ancho REAL
      const realFilledWidth = graphWidth * percentage
      const percentageText =
        percentage > 0 ? `${(percentage * 100).toFixed(2)}%` : ""
      // Medir texto
      doc.setFont("Cairo-SemiBold", "normal")
      doc.setFontSize(8)
      const textWidth = doc.getTextWidth(percentageText)

      // ANCHO MÍNIMO: el texto completo + 3mm de margen interno
      const MIN_WIDTH_WITH_TEXT = textWidth + 3

      // Ancho FINAL de la barra azul
      let finalFilledWidth = realFilledWidth
      if (percentage > 0 && realFilledWidth < MIN_WIDTH_WITH_TEXT) {
        finalFilledWidth = MIN_WIDTH_WITH_TEXT
        if (finalFilledWidth > graphWidth) finalFilledWidth = graphWidth
      }

      // === DIBUJAR BARRA AZUL CON BORDE REDONDEADO IZQUIERDO ===
      doc.setFillColor(10, 85, 135)

      if (percentage > 0) {
        doc.roundedRect(
          sideMargin,
          y,
          borderRadius * 2,
          graphHeight,
          borderRadius,
          borderRadius,
          "F"
        )

        doc.rect(
          sideMargin + borderRadius,
          y,
          finalFilledWidth - borderRadius,
          graphHeight,
          "F"
        )
      }
      // Calcular posición del texto centrado
      const textX = sideMargin + finalFilledWidth / 2 - textWidth / 2
      const textY = y + graphHeight / 2 + 0.8

      if (percentageText) {
        doc.setTextColor("#FFFFFF")
        doc.text(percentageText, textX, textY)
      }

      y += graphHeight
    } catch (err) {
      console.error("Error renderizando gráfica budget:", err)
    }
  }

  y += 6

  doc.setDrawColor(204, 212, 222)
  doc.setLineWidth(0.3)
  doc.line(sideMargin, y, pageWidth - sideMargin, y)

  return y + 10
}
